module.exports = __webpack_public_path__ + "media/entities/1002-1d3aedac.png";